import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/clients/$clientId')({
  // `?agency=<tenantId>` = platform-admin oversight: resolve + drill into this
  // client in that agency's context instead of the caller's own list (T08).
  // `?page=` (EW-T03) — the Entities tab's server-paginated page number, via
  // `usePaginationState`. Must be declared here (this `validateSearch` is an allowlist, not a
  // passthrough) or the router strips it on every navigate. Only one server-paginated table lives
  // on this route (Workers-tab pagination is a confirmed blocker, not built), so no namespacing
  // against a second `page`-consuming widget is needed.
  validateSearch: (search: Record<string, unknown>): { agency?: string; tab?: string; page?: number } => ({
    agency: typeof search.agency === 'string' ? search.agency : undefined,
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    page: typeof search.page === 'number' && search.page > 1 ? search.page : undefined,
  }),
});
